import { render, staticRenderFns } from "./SpacingSection.vue?vue&type=template&id=1bf7e30f&scoped=true"
import script from "./SpacingSection.vue?vue&type=script&lang=js"
export * from "./SpacingSection.vue?vue&type=script&lang=js"
import style0 from "./SpacingSection.vue?vue&type=style&index=0&id=1bf7e30f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf7e30f",
  null
  
)

export default component.exports